const getHeapInstance = () => window.heap

export default getHeapInstance
